import gql from 'graphql-tag';

export const Good360FullFragment = gql`
	fragment Good360FullFragment on Good360 {
		id
		localId
		status
		Good {
			id
			name
		}
	}
`;